import React from "react";
import { Button, Tooltip } from "antd";
import { BarChart3 } from "lucide-react";
import { useTranslation } from "react-i18next";

const UsageAccessButton = ({
    isLoading,
    onOpen,
}) => {
    const { t } = useTranslation("review");
    const button = (
        <Button
            type="text"
            className="commercial-usage-access-button"
            icon={<BarChart3 size={16} strokeWidth={1.9} />}
            loading={isLoading}
            onClick={onOpen}
            aria-label={t("commercial.usage.title", { defaultValue: "Plan et usage" })}
        />
    );

    return (
        <Tooltip title={t("commercial.usage.title", { defaultValue: "Plan et usage" })} placement="bottomRight">
            {button}
        </Tooltip>
    );
};

export default UsageAccessButton;
